import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseControl } from "@app/shared/index";
import { Annulation } from '../models/anulacion.model';
import { AnnulationProcessDataService } from './shared/annulation-process.data.service';
import { AnnulationProcessFormService } from './shared/annulation-process.form.service';

@Component({
  selector: 'iw-annulation-process',
  templateUrl: './annulation-process.component.html',
  styleUrls: ['./annulation-process.component.scss'],
  providers: [AnnulationProcessFormService, AnnulationProcessDataService]
})
export class AnnulationProcessComponent implements OnInit {
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene la información de anulación del trámite
  @Input() annulation: Annulation = {};
  // Contiene el expediente
  @Input() expediente: string;
  // Contiene el id del trámite
  @Input() tramite: number;
  // Emite la anulación para recargar el flujo
  @Output() validAnnul: EventEmitter<boolean> = new EventEmitter();

  constructor(private apfs: AnnulationProcessFormService, private apds: AnnulationProcessDataService) { }

  ngOnInit() {
    if(this.annulation && this.annulation.id){
      let values: any = {
        motivo: this.annulation.motivo
      }
      this.controls = this.apfs.getForm(values);
    }else{
      this.controls = this.apfs.getForm();
    }
  }

  /**
   *Controla el evento anular de los controles
   *
   * @param {*} data
   * @memberof AnnulationProcessComponent
   */
  sended(data: any){
    this.apds.annulation(this.tramite, 'proceso', data.textarea).subscribe(res=>{
      if(res){
        this.validAnnul.emit(true)
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/annulation-process/annulation-process.component.ts